import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Тохиргоо")
const _hoisted_5 = { class: "card shadow" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon-s-tools fs-2 text-dark" }),
    /*#__PURE__*/_createTextVNode(" "),
    /*#__PURE__*/_createElementVNode("b", null, "Тохиргоо")
  ])
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Хадгалах ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.settingsLoading)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              model: _ctx.settingsForm,
              "status-icon": "",
              ref: "saveSettingsForm",
              rules: _ctx.settingsFormRule,
              "label-width": "200px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "Хэдэн минутанд",
                  prop: "maxActiveTime",
                  "label-width": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.settingsForm.maxActiveTime,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settingsForm.maxActiveTime) = $event)),
                      size: "mini"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Хэдэн удаа",
                  prop: "maxCount",
                  "label-width": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.settingsForm.maxCount,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settingsForm.maxCount) = $event)),
                      size: "mini"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Идэвхигүй байх хугацаа",
                  prop: "InActiveMin",
                  "label-width": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.settingsForm.InActiveMin,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settingsForm.InActiveMin) = $event)),
                      size: "mini"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Мал тооллогын сервис",
                  prop: "headCount",
                  "label-width": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.settingsForm.headCount,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.settingsForm.headCount) = $event)),
                      size: "mini"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : (_openBlock(), _createBlock(_component_el_skeleton, {
              key: 1,
              rows: 4,
              animated: ""
            }))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          size: "mini",
          type: "primary",
          ref: "submitButton",
          loading: _ctx.saveButtonLoader,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formSubmit()))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          size: "mini",
          type: "primary",
          ref: "submitHideButton",
          hidden: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveSettings()))
        }, null, 512)
      ])
    ])
  ], 64))
}